import { LucideIcon, ShoppingBag, User } from 'lucide-react'

import { Card, CardHeader, CardTitle } from '@/components/ui/card'
import { Tabs, TabsContent } from '@/components/ui/tabs'

import { UnderlinedTabsList } from '@/components/atoms/UnderlinedTabsList'

const tabs = [
  { label: 'Order history', value: 'orders' },
  { label: 'Activity', value: 'activity' },
]

const ComingSoon = ({ icon: Icon, title, description }: { icon: LucideIcon; title: string; description: string }) => (
  <div className="flex flex-col items-center justify-center px-4 py-12 text-center">
    <span className="mb-4 grid size-16 place-items-center rounded-full bg-subdued" aria-hidden="true">
      <Icon className="size-6 text-faint" />
    </span>
    <h3 className="text-heading-md text-ink">{title}</h3>
    <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
  </div>
)

export const CustomerActivityTabs = () => {
  return (
    <Card className="overflow-hidden">
      <CardHeader className="pb-0">
        <CardTitle>Activity</CardTitle>
      </CardHeader>
      <Tabs defaultValue="orders" className="w-full">
        <UnderlinedTabsList tabs={tabs} className="px-2" />

        <TabsContent value="orders" className="mt-0">
          <ComingSoon
            icon={ShoppingBag}
            title="No order history yet"
            description="Order history will be available soon."
          />
        </TabsContent>

        <TabsContent value="activity" className="mt-0">
          <ComingSoon
            icon={User}
            title="No activity yet"
            description="The activity log will be available soon."
          />
        </TabsContent>
      </Tabs>
    </Card>
  )
}
